import './Clients.css'
import React from 'react'

import Content from './Content'
import Link from './Link'

export default ({ title, content, client}) =>
    <section className='clients'>
        <div className='container'>
            {title && <h2>{title}</h2>}
            {content && <Content src={content} />}
            {!!client.length && 
                <div className='clients-container'>
                    {client.map(({ image, url }, index) => {
                        
                        return url !== '#' ? 
                            <Link className='client' to={url} key={index}>
                                <img src={image} alt={url} />
                            </Link>
                            : <span className='client' key={index}>
                                <img src={image} alt={url} />
                            </span>
                    }
                       
                    )}
                </div>
            }
        </div>
    </section>


// WEBPACK FOOTER //
// ./src/components/Clients.js